import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
@Injectable()
export class LoaderService {
    isLoading = new Subject<boolean>();

    private theBoolean: BehaviorSubject<boolean>;

    show() {

        this.isLoading.next(true);
        this.theBoolean = new BehaviorSubject<boolean>(true);
    }
    hide() {
        this.isLoading.next(false);

        this.theBoolean = new BehaviorSubject<boolean>(false);
    }

    public getTheBoolean(): Observable<boolean> {
      return this.theBoolean.asObservable();
    }
}
